<template>
  <div class="cc-dpd-parcel-shop" @click.prevent.stop>
    <div class="cc-dpd-parcel-shop__header">
      <div class="cc-dpd-parcel-shop__title mb-2" v-if="dpdParcelShop.selected.id">{{ dpdParcelShop.selected.name }}</div>
      <button class="cc-button cc-button--delivery-branch btn btn-primary" @click.stop="openWidget">{{ deliveryBranchButtonName }}</button>
    </div>
    <div class="cc-dpd-parcel-shop__main" v-if="isWidgetVisible">
      <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
        <div class="cc-popup__content">
          <div class="cc-popup__header">
            <div class="cc-popup__title">{{ translations['Search for parcel shop'] }}</div>
          </div>
          <div class="cc-popup__main">
            <div class="cc-form-input">
              <label for="dpdParcelShop.search" class="cc-label cc-label--text">{{ translations['Postal code or city'] }}</label>
              <input id="dpdParcelShop.search" type="text" name="dpdParcelShop.search" class="cc-input cc-input--text" @keyup.enter="search" v-model="searchQuery">
            </div>
            <table class="cc-table" v-if="dpdParcelShop.result.length > 0">
              <thead class="cc-table__thead">
              <tr class="cc-table__tr">
                <th class="cc-table__th">
                  {{ translations['Parcel shop'] }}
                </th>
                <th class="cc-table__th">
                  {{ translations['Street'] }}
                </th>
                <th class="cc-table__th">
                  {{ translations['Controls'] }}
                </th>
              </tr>
              </thead>
              <tbody class="cc-table__tbody">
              <tr v-for="postOffice in dpdParcelShop.result" v-bind:key="postOffice.id" class="cc-table__tr">
                <td class="cc-table__td">
                  {{ postOffice.naz_prov }}
                </td>
                <td class="cc-table__td">
                  {{ postOffice.adresa }}
                </td>
                <td class="cc-table__td">
                  <button class="cc-button cc-button--select-post-office btn btn-primary btn-sm" :data-post-office-id="postOffice.id" :data-post-office-name="postOffice.naz_prov+' - '+postOffice.adresa" @click.prevent.stop="selectBranch">{{ translations['Select branch'] }}</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="cc-popup__footer">
            <button class="cc-button cc-button--popup-cancel btn btn-secondary" @click.prevent.stop="closeWidget">{{ translations['Cancel'] }}</button>
            <button class="cc-button cc-button--popup-ok btn btn-success" @click.prevent.stop="search">{{ translations['Search'] }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="cc-dpd-parcel-shop__main--big" v-if="isBigWidgetVisible">
      <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isBigWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
        <div class="cc-popup__content">
          <div class="cc-popup__main">
            <iframe id="dpd-parcelshop-map" class="mapa_iframe" :title="translations['Select parcel shop']" width="100%" height="800px" allow="geolocation" src="https://api.dpd.cz/widget/latest/index.html"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      dpdParcelShop: state => state.dpdParcelShop,
    }),
    deliveryBranchButtonName: function () {
      return this.dpdParcelShop.selected.id ? this.translations['Change'] : this.translations['Select branch'];
    },
    isWidgetVisible: function () {
      if (this.carrier.extra.widget === true) {
        return false;
      }
      if (this.selectedCarrier === null) {
        return this.shouldWidgetBeShown;
      }
      if (this.selectedCarrier.module === 'shaim_dpdparcelshop' && this.dpdParcelShop.selected.id === null) {
        return true;
      }

      return this.shouldWidgetBeShown;
    },
    isBigWidgetVisible: function () {
      if (this.carrier.extra.widget === false) {
        return false;
      }
      if (this.selectedCarrier === null) {
        return this.shouldWidgetBeShown;
      }
      if (this.selectedCarrier.module === 'shaim_dpdparcelshop' && this.dpdParcelShop.selected.id === null) {
        return true;
      }

      return this.shouldWidgetBeShown;
    }
  },
  data: function () {
    return {
      shouldWidgetBeShown: false,
      searchQuery: '',
    };
  },
  methods: {
    openWidget: function () {
      this.$store.commit('SET_DPD_PARCEL_SHOP_SEARCH', '');
      this.$store.commit('SET_DPD_PARCEL_SHOP_POST_OFFICES', {});
      this.shouldWidgetBeShown = true;
    },
    closeWidget: function () {
      if (this.dpdParcelShop.selected.id === null) {
        this.$emit('closeWithoutParcelShop');
      }
      this.shouldWidgetBeShown = false;
      this.searchQuery = "";
    },
    search: function () {
      this.$store.commit('SET_DPD_PARCEL_SHOP_SEARCH', this.searchQuery.replaceAll(' ',''));
      this.$store.dispatch('LOAD_DPD_PARCEL_SHOPS');
    },
    selectBranch: function (event) {
      this.$store.commit('SET_DPD_PARCEL_SHOP_SELECTED_POST_OFFICE', {id: event.currentTarget.dataset.postOfficeId, name: event.currentTarget.dataset.postOfficeName});
      this.closeWidget();
      this.$store.commit('SET_DPD_PARCEL_SHOP_SEARCH', '');
      this.$store.commit('SET_DPD_PARCEL_SHOP_POST_OFFICES', {});
      this.$emit('selectCarrier', this.carrier)
    },
    iframeListener: function (event) {
      if(event.data.dpdWidget) {
        if (event.data.dpdWidget.message === "widgetClose") {
          this.$emit('closeWithoutParcelShop');
          this.shouldWidgetBeShown = false;
        } else {
          var id = event.data.dpdWidget.id.replace(/\D/g, '');
          var full = event.data.dpdWidget.contactInfo.name + ', ' + event.data.dpdWidget.location.address.street + ', ' + event.data.dpdWidget.location.address.city;

          if (id) {
            this.$store.commit('SET_DPD_PARCEL_SHOP_SELECTED_POST_OFFICE', {
              id: id,
              name: full
            });
            this.closeWidget();
            this.$emit('selectCarrier', this.carrier)
          }
        }
      }
    }
  },
  mounted() {
    if (this.carrier.extra.widget) {
      window.addEventListener("message", this.iframeListener);
    }
  },
  name: 'DpdParcelShop',
  props: [
    'carrier',
    'selectedCarrier',
  ],
};
</script>

<style lang="scss" scoped="scoped">
@import "../_common/scss/popups";
@import "../_common/scss/tables";
#app {
  .cc-table {
    margin-top: 1rem;
  }
}
#app .cc-table__td {
  padding: 0.5rem 1rem;
}
.cc-input.cc-input--text {
  padding: 1rem;
}
.cc-dpd-parcel-shop .cc-table__tr {
  border-top: 1px solid #eeeeee;
}
.cc-button {
  white-space: nowrap;
}

/* big widget */
#app .cc-dpd-parcel-shop__main--big .cc-popup__content {
  top: auto;
  left: auto;
  -webkit-transform: none;
  transform: none;
  min-width: calc(100% - 2rem);
  max-width: 100%;
  padding: 0;
}

#app .cc-popup__main {
  padding: 0;
}

</style>
